<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters class="h-screen sm:flex-row flex-col">
      <!-- Straight Section -->

      <v-col class="straight-screen !relative sm:!h-screen h-1/3 ">
        <v-btn
          class="ma-2 straight_color border-0 rounded-lg left-1/2 -translate-x-1/2  sm:!bottom-6 sm:translate-y-0 translate-y-1/2 !bottom-1/2   !absolute font-Handel !text-lg"
          x-large width="200px" outlined @click.prevent="setInterest(3)">
          For
          <img class="ml-6 " src="../../../assets/img/icons/straight/date.png" alt="" />
        </v-btn>
      </v-col>

      <!-- Straight end Section -->

      <!-- Lesbian Section -->
      <v-col class="lesbian-screen !relative sm:!h-screen h-1/3 ">

        <v-btn
          class="ma-2  border-0 lesbian_color rounded-lg left-1/2 -translate-x-1/2  sm:!bottom-6 sm:translate-y-0 translate-y-1/2 !bottom-1/2  !absolute font-Handel !text-lg"
          x-large width="200px" outlined @click.prevent="setInterest(1)">
          For
          <img class="ml-6" src="../../../assets/img/icons/lesbian/date.png" alt="" />
        </v-btn>

      </v-col>
      <!-- Lesbian end Section -->

      <!-- Gay Section -->
      <v-col class="gay-screen !relative sm:!h-screen h-1/3 ">

        <v-btn
          class="ma-2 gay_color border-0 rounded-lg left-1/2 -translate-x-1/2  sm:!bottom-6 sm:translate-y-0 translate-y-1/2 !bottom-1/2  !absolute font-Handel !text-lg"
          x-large width="200px" outlined @click.prevent="setInterest(2)">
          For
          <img class="ml-6" src="../../../assets/img/icons/gay/date.png" alt="" />
        </v-btn>

      </v-col>

      <!-- Gay end Section -->
    </v-row>
  </v-container>
</template>
:gradient="`${routeLink}` == 'straight' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)' : `${routeLink}` == 'gay' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,145,236,1)' : `${routeLink}` == 'lesbian' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(69,17,81,1)' : ''"
<style scoped>
.straight-screen {
  background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)) , url("../../../assets/images/dating.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;


}

.lesbian-screen {
  background:  linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(69,17,81,1)) ,url("../../../assets/images/girl7.jpg") ;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;


}

.gay-screen {
  position: relative;

  background:  linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,145,236,1)) ,url("../../../assets/images/gay.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;

}


.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%);
}
</style>

<script>
import axios from "axios";
export default {
  name: "Interest",
  methods: {
    async setInterest(interest) {
      try {
        const resp = await axios.post("/complete-profile", {
          account_type: interest,
        });
        // await this.$store.commit("restoreData", resp.data);
        // localStorage.setItem("userInfo", JSON.stringify(resp.data));
        this.$router.push("/complete-profile");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
